// extracted by mini-css-extract-plugin
export default {"col_L":"index_col_L_T5krm","space10":"index_space10_hqS3F","space20":"index_space20_eUisD","space3":"index_space3_sYtr4","ad":"index_ad_pw-yW","ad_box":"index_ad_box_21kUb"};